import { GameScene } from '@Core/GameScene/GameScene';
import { Slot } from '@esotericsoftware/spine-pixi-v8';
import { Container } from 'pixi.js';
import SpineWrapper from './SpineWrapper';

export type TObjectAssignableToSlot = { spine: SpineWrapper; container: Container; slot: Slot; id?: string };
export const SLOT_TRANSLATION_CHARACTER = 'T_';

export default class SpineWrapperSlotManager {
    public scene: GameScene;
    public spineWrapper: SpineWrapper;
    public objectsAssignedToSlot: { [key in string]: TObjectAssignableToSlot } = {};

    constructor(scene: GameScene, spineWrapper: SpineWrapper) {
        this.scene = scene;
        this.spineWrapper = spineWrapper;
    }

    public removeAttachmentFromSlot(slotName: string): void {
        const slot = this.spineWrapper.spine.skeleton.findSlot(slotName);

        if (!slot) return console.warn('Cannot find slot ', slotName);

        //! phaser-spine-v3 has wrong type here
        (this.spineWrapper.spine.skeleton as any).setAttachment(slotName, null);
    }

    public assignObjectToSlot(slotName: string, container: Container, id?: string): void {
        const slot = this.spineWrapper.spine.skeleton.findSlot(slotName);
        if (!slot) return console.warn('Cannot find slot ', slotName, 'for spine ', this.spineWrapper.dataKey);
        const slotObject = { spine: this.spineWrapper, container, slot, id };
        this.objectsAssignedToSlot[slotName] = slotObject;
        this.spineWrapper.spine.addSlotObject(slot, container, { followSlotColor: true });
    }

    public unassignObjectFromSlot(slotName: string): void {
        const slot = this.spineWrapper.spine.skeleton.findSlot(slotName);
        if (!slot) return console.warn('Cannot find slot ', slotName, 'for spine ', this.spineWrapper.dataKey);
        if (!this.objectsAssignedToSlot[slotName])
            return console.warn('Trying to remove unassigned object from slot ', slotName, 'for spine ', this.spineWrapper.dataKey);
        this.spineWrapper.spine.removeSlotObject(this.objectsAssignedToSlot[slotName].container);
        delete this.objectsAssignedToSlot[slotName];
    }

    public getAllTranslatableSlotNames(): string[] {
        return this.spineWrapper.spine.skeleton.slots.map((slot) => slot.data.name).filter((name) => name.startsWith(SLOT_TRANSLATION_CHARACTER));
    }
}
